import React from 'react'
import { Button } from 'antd'
// import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { PrinterOutlined } from '@ant-design/icons'

function Print({
  type = 'default',
  icon = <PrinterOutlined />,
  title = 'button.print',
  onClick = () => {},
  id = 'btn-print',
  ...props
}) {
  const { formatMessage } = useIntl()
  const newTitle = title === 'button.print' ? formatMessage({ id: title }) : title

  return (
    <Button type={type} icon={icon} onClick={onClick} id={id} {...props}>
      {newTitle}
    </Button>
  )
}

// Print.propTypes = {
//   type: PropTypes.string,
//   icon: PropTypes.object,
//   title: PropTypes.string,
//   id: PropTypes.string,
//   onClick: PropTypes.func,
// }

export default Print
